<template>
  <div class="rc-access-points">
    <ul
      v-if="items.length"
      class="rc-list-access-points"
    >
      <li
        v-for="(item, index) in items"
        :key="index"
      >
        <rc-btn
          block
          class="mx-auto"
          variant="lighter"
          @click="$emit('selected', item)"
        >
          <div>{{ item.name }}</div>
          <div class="rc-distance">
            {{ item.distance.toFixed(1) }} km
          </div>
          <span class="visually-hidden">{{ $t("a11y.button.more") }}</span>
        </rc-btn>
      </li>
    </ul>
    <ul
      v-else
      class="rc-list-access-points"
    >
      <li
        v-for="(item, index) in 6"
        :key="index"
      >
        <rc-btn
          block
          class="mx-auto"
          variant="lighter"
        >
          <div
            class="rc-skeleton rc-skeleton-text rc-skeleton-animate-wave"
            style="width: 75%"
          />
          <div
            class="rc-skeleton rc-skeleton-text rc-skeleton-animate-wave"
            style="width: 25%"
          />
        </rc-btn>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'RcSubscriberList',

  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  emits: ['selected']
};
</script>
